<style>
  .ivu-table .table-last-row td{background-color: #fff9dc;color:#f00}
  .ivu-table-tip td{width:100% !important}
  .company-card .ivu-card-head{background-color: #f7f7f7}
  .company-card .total{border-radius: 0 0 4px 4px;padding:5px 0;}
</style>
<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" v-model="activeTab">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div slot="slogan"></div>
    <div class="activity-item mgui-container" slot="/report/form">
      <report-form-component></report-form-component>
    </div>
    <div class="activity-item mgui-container" slot="/report/department">
      <Button type="primary" @click="exportTable">导出</Button>
      <Divider></Divider>
      <Row :gutter="16">
        <Col span="8" v-for="(item, ind) in projectCount" :key="ind" style="margin-bottom:16px">
          <Card :title="item.department" :padding="0">
            <!-- <div slot="title">{{}}</div> -->
            <CellGroup>
              <Cell title="预估产值" style="border-bottom:1px solid #eee;" :extra="(item.expected?parseFloat(item.expected):0).toFixed(2) + ' 元'" />
              <Cell title="合同确认产值" style="border-bottom:1px solid #eee;" :extra="(item.confirm?parseFloat(item.confirm):0).toFixed(2) + ' 元'" />
              <Cell title="未确认产值" style="border-bottom:1px solid #eee;" :extra="((item.expected - item.confirm)?parseFloat(item.expected - item.confirm):0).toFixed(2) + ' 元'" />
              <Cell title="已经到款" style="background:#eeffe8;border-bottom:1px solid #eee;color:green" :extra="(item.money?parseFloat(item.money):0).toFixed(2) + ' 元'" />
              <Cell title="未到款" style="background:#fff5df;color:red" :extra="((item.confirm - item.money)?parseFloat(item.confirm - item.money):0).toFixed(2) + ' 元'" />
            </CellGroup>
          </Card>
        </Col>
      </Row>
    </div>
    <div class="activity-item mgui-container" slot="/report/count">
      <div class="filter-row" style="text-align:right">
        <ButtonGroup>
          <Button :type="filter.type=='pro'?'primary':'default'" @click="filter.type='pro';fetchCount()">按项目汇总</Button>
          <Button :type="filter.type=='year'?'primary':'default'" @click="filter.type='year';fetchCount()">按年份汇总</Button>
        </ButtonGroup>
        <template v-if="filter.type=='year'">
          &nbsp;&nbsp;
          到款日期：<DatePicker v-model="filter.year" type="year" style="width:100px" placeholder="选择日期" @on-change="fetchCount"></DatePicker>
        </template>
        &nbsp;&nbsp;
        <Button type="primary" @click="exportData"><Icon type="ios-download-outline"></Icon> 导出</Button>
        &nbsp;&nbsp;<span style="color:#999">|</span>&nbsp;&nbsp;
        部门：
        <Select v-model="filter.department"  @on-change="fetchCount" style="width:100px;text-align:left">
          <Option :value="0">所有</Option>
          <Option v-for="(item,ind) in $store.state.department" :key="ind" :value="item.value | toString">{{item.label}}</Option>
        </Select>
        <!-- <Select v-model="filter.department" style="text-align:left;width:160px">
          <Option value="all">ALL</Option>
            <Option v-for="item in projects" :value="item.id" :key="item.id">{{ item.project }}({{ item.company }})</Option>
        </Select> -->
        <!-- <Button icon="ios-search" @click="fetchCount">筛选</Button> -->
        <!-- <span style="color:#999;padding:0 10px;">|</span> -->
      </div>
      <div v-if="filter.type == 'year'">
        <Table ref="yearTable" border stripe :columns="reportsColumns" :row-class-name="rowClassName" :data="reports.data"></Table>
        <div class="pager">
          <Page :current="reports.current_page" :page-size="reports.per_page"  :total="reports.total" @on-change="reportsPageChange" simple></Page>
        </div>
      </div>
      <div v-else>
        <Row :gutter="6">
          <template v-for="(item, ind) in reports.data" >
            <template v-if="item.name!=''">
            <Col span="8" :key="ind">
              <Card class="company-card" :key="'card'+ind">
                  <h5 slot="title">
                      {{item.project}} <small style="font-size:12px;color:#f00;">{{item.status == 1 ? '[项目已完结]' : ''}}</small>
                  </h5>
                  <a href="#" slot="extra" @click.prevent="changeLimit" style="font-size:12px">
                      <Icon type="ios-time-outline" /> 项目时间:
                      {{item.year}}
                  </a>
                  <ul>
                      <li v-if="item.children.length==0" style="font-size:12px;color:#999">-- 暂无记录 --</li>
                      <li v-for="child in item.children" :key="child.id" style="line-height:30px;border-bottom:1px solid #eee">
                        <span style="float:right;color:#999;font-size:12px">
                          <Icon type="ios-time-outline" /> 到款时间:
                          {{child.year}}-{{child.month}}
                        </span>
                          <a href="#">¥ {{ child.money }} 元</a>
                      </li>
                      <li class="total" v-if="item.total>0">合计：¥ {{item.total}} 元</li>
                  </ul>
              </Card>
            </Col>
            <Col span="24" :key="ind" style="border-bottom:1px solid #eee;padding-top:10px;margin-bottom:10px;" v-if="(ind+1)%3==0"></Col>
            </template>
          </template>
        </Row>
      </div>
    </div>
    <div class="activity-item mgui-container" slot="/report/project">
      <div class="filter-row" style="text-align:right">
        日期：<DatePicker :open="dateOpen" :value="filterProject.year" type="year" confirm placeholder="选择日期" @on-change="dateChange" @on-ok="fetchProject">
          <Button href="javascript:void(0)" @click="dateClick">
            <Icon type="ios-calendar-outline"></Icon>
            <template v-if="filterProject.year === ''">选择项目时间</template>
            <template v-else>{{ filterProject.year }}</template>
          </Button>
        </DatePicker>
        &nbsp;&nbsp;部门：
        <Select v-model="filterProject.department" style="width:160px;text-align:left" @on-change="departmentChange">
          <Option :value="0">All</Option>
          <Option v-for="(item, index) in departmentGroup" :value="item.id" :key="index">{{item.name}}</Option>
        </Select>
        &nbsp;|&nbsp;
        <Button icon="ios-plus" type="primary" @click="addProjectForm=true">添加项目</Button>
      </div>
      <div>
        <Table border :columns="columns" :data="project.data"></Table>
        <div class="pager"><Page :current="project.current_page" :page-size="project.per_page" :total="project.total" @on-change="projectPageChange" simple></Page></div>
      </div>
      <Modal
        title="添加/编辑项目"
        v-model="addProjectForm"
        @on-ok="addProject"
        @on-visible-change="modalVisibleChange"
        >
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
          <FormItem label="部门" prop="department">
            <!-- <Select v-model="formValidate.department" style="width:160px;text-align:left">
              <Option v-for="(item, index) in departmentGroup" :value="item.id" :key="index">{{item.name}}</Option>
            </Select> -->
            <Cascader v-model="dids" v-if="addProjectForm" placeholder="选择项目组" :data="$store.state.department" @on-change="cascaderChange"></Cascader>
          </FormItem>
          <FormItem label="项目名称" prop="project">
              <Input v-model="formValidate.project" placeholder="请输入项目名称"></Input>
          </FormItem>
          <FormItem label="项目年份" prop="year">
            <DatePicker type="year" placeholder="请选择项目年份" v-model="formValidate.year"></DatePicker>
          </FormItem>
          <FormItem label="客户单位" prop="company">
              <Input v-model="formValidate.company" placeholder="请输入客户单位"></Input>
          </FormItem>
          <FormItem label="项目地" prop="city">
              <Input v-model="formValidate.address" placeholder="项目地"></Input>
          </FormItem>
          <FormItem label="预估产值" prop="expected">
              <Input placeholder="请输入预估产值" number v-model="formValidate.expected"></Input>
          </FormItem>
          <FormItem label="合同确认产值" prop="confirm">
              <Input placeholder="请输入合同确认产值" number v-model="formValidate.confirm"></Input>
          </FormItem>
          <FormItem label="未确认产值" prop="unconfirmed">
              <Input placeholder="请输入未确认产值" number v-model="formValidate.unconfirmed"></Input>
          </FormItem>
          <FormItem label="备注">
              <Input type="textarea" placeholder="请输入未确认产值" v-model="formValidate.remarks"></Input>
          </FormItem>
        </Form>
      </Modal>
    </div>
  </content-layout>
</template>


<script>
  import {fetch, put, post, del} from '../fetch/api'
  import reportFormComponent from '../components/ReportFormComponent'
  var moneyArr = [{month: 1, money: '--'}, {month: 2, money: '--'}, {month: 3, money: '--'}, {month: 4, money: '--'}, {month: 5, money: '--'}, {month: 6, money: '--'}, {month: 7, money: '--'}, {month: 8, money: '--'}, {month: 9, money: '--'}, {month: 10, money: '--'}, {month: 11, money: '--'}, {month: 12, money: '--'}]

  export default {
    name: 'reportForm',
    components: {
      reportFormComponent,
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) }
    },
    data () {
      var date = new Date()
      var year = String(date.getFullYear())
      return {
        title: '应收款',
        tabs: [],
        year: year,
        headImage: '/static/images/bg/money.jpeg',
        activeTab: null,
        spinShow: true,
        pickerOpen: false,
        results: {
          total: 0
        },
        companyIndex: 0,
        currentDepartment: 0,
        department: 0,
        departmentGroup: [],
        dateOpen: false,
        filterProject: {
          department: 0,
          year: ''
        },
        report: {
          data: [],
          current_page: 1,
          to: 0,
          total: 0
        },
        reports: {
          data: [],
          current_page: 1,
          to: 0,
          total: 0
        },
        project: {
          data: [],
          current_page: 1,
          to: 0,
          total: 0
        },
        projectParams: {
          page: 1,
          department: 0,
          year: 0
        },
        columns: [
          {
            title: '部门',
            width: 100,
            fixed: 'left',
            sortable: true,
            render: (h, params) => {
              return h('span', params.row.pro.name)
            }
          },
          {
            title: '项目名称',
            width: 240,
            fixed: 'left',
            key: 'project',
            render: (h, params) => {
              return h('div', [
                h('div', params.row.company),
                h('div', params.row.project)
              ])
            }
          },
          {
            title: '时间',
            fixed: 'left',
            width: 70,
            key: 'year'
          },
          {
            title: '预估产值',
            width: 150,
            key: 'expected'
          },
          {
            title: '合同确认产值',
            width: 150,
            key: 'confirm'
          },
          {
            title: '未确认产值',
            width: 150,
            render: (h, params) => {
              var val = params.row.expected - params.row.confirm
              return h('span', val.toFixed(2))
            }
          },
          {
            title: '已经到款',
            ellipsis: true,
            tooltip: true,
            width: 120,
            render: (h, params) => {
              var child = params.row.form
              var count = 0
              for (let k in child) {
                count += Number(child[k].money)
              }
              return h('span', '+ ' + count)
            }
          },
          {
            title: '未到款',
            width: 150,
            key: 'unconfirmed',
            render: (h, params) => {
              var child = params.row.form
              var count = 0
              for (let k in child) {
                count += Number(child[k].money)
              }
              var price = Math.abs(params.row.confirm - count)
              price = price.toFixed(2)
              return h('span', '- ' + price)
            }
          },
          {
            title: '日志',
            width: 64,
            align: 'center',
            render: (h, params) => {
              let loglist = []
              let log = params.row.log
              if (log.length > 0) {
                for (let k in log) {
                  loglist.push(h('TimelineItem', {style: {textAlign: 'left'}}, [
                    h('p', {class: 'time'}, `${log[k].updated_at}`),
                    h('p', {class: 'content'}, [
                      h('p', `预估产值：￥${log[k].expected}`),
                      h('p', `确认产值：￥${log[k].confirm}`),
                      h('Tag', `备注：${log[k].remarks}`)
                    ])
                  ]))
                }
              } else {
                loglist.push(h('p', {style: {color: '#999'}}, '暂无记录'))
              }

              return h('Poptip', {
                props: {
                  placement: 'bottom'
                }
              }, [
                h('a', {
                  class: 'ivu-icon ivu-icon-android-arrow-dropdown-circle',
                  props: {
                    type: 'text',
                    size: 'small',
                    icon: 'ios-more'
                  }
                }),
                h('div', {
                  style: {
                    height: '200px',
                    overflow: 'auto'
                  },
                  slot: 'content'
                }, loglist)
              ])
            }
          },
          {
            title: '操作',
            width: 180,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.status === 1 ? 'none' : ''
                  },
                  on: {
                    click: () => {
                      this.edit(params.row)
                    }
                  }
                }, '编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: params.row.status === 1
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.end(params.row)
                    }
                  }
                }, params.row.status === 0 ? '完结' : '已完结'),
                h('Button', {
                  style: {
                    display: params.row.status === 1 ? 'none' : ''
                  },
                  props: {
                    type: 'default',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.del(params.row)
                    }
                  }
                }, '删除')
              ])
            }
          }
        ],
        filter: {
          type: 'pro',
          department: '0',
          year: year
        },
        yearMonth: '',
        addProjectForm: false,
        current_project_id: 0,
        dids: [],
        formValidate: {
          id: 0,
          project: '',
          department: '',
          year: '',
          company: '',
          expected: '',
          confirm: '',
          unconfirmed: ''
        },
        ruleValidate: {
          project: [
            { required: true, message: '请输入项目名称', trigger: 'blur' }
          ],
          company: [
            { required: true, message: '请输入客户单位', trigger: 'blur' }
          ],
          year: [
            { required: true, type: 'date', message: '请选择年份', trigger: 'change' }
          ],
          expected: [
            { type: 'number', message: '请输入数字', trigger: 'blur' }
          ],
          confirm: [
            { type: 'number', message: '请输入数字', trigger: 'blur' }
          ],
          unconfirmed: [
            { type: 'number', message: '请输入数字', trigger: 'blur' }
          ]
        },
        projects: [],
        ruleFormValidate: {},
        reportsColumns: [
          {
            width: 60,
            fixed: 'left',
            align: 'center',
            key: 'id'
          },
          {
            title: '部门',
            width: 100,
            fixed: 'left',
            sortable: true,
            render: (h, params) => {
              return h('span', params.row.pro !== undefined ? params.row.pro.name : '')
            }
          },
          {
            title: '项目名称',
            fixed: 'left',
            ellipsis: true,
            tooltip: true,
            width: 300,
            render: (h, params) => {
              return h('div', [
                h('div', params.row.company),
                h('div', params.row.project)
              ])
            }
          },
          {
            title: '年',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              return h('span', params.row.year)
            }
          },
          {
            title: '1月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[0].money)
            }
          },
          {
            title: '2月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[1].money)
            }
          },
          {
            title: '3月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[2].money)
            }
          },
          {
            title: '4月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[3].money)
            }
          },
          {
            title: '5月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[4].money)
            }
          },
          {
            title: '6月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[5].money)
            }
          },
          {
            title: '7月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[6].money)
            }
          },
          {
            title: '8月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[7].money)
            }
          },
          {
            title: '9月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[8].money)
            }
          },
          {
            title: '10月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[9].money)
            }
          },
          {
            title: '11月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[10].money)
            }
          },
          {
            title: '12月',
            align: 'center',
            minWidth: 140,
            render: (h, params) => {
              return h('span', params.row.money[11].money)
            }
          },
          {
            title: '到款合计',
            width: 120,
            fixed: 'right',
            render: (h, params) => {
              return h('span', '¥' + params.row.total + '元')
            }
          }
        ],
        projectCount: []
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      }
    },
    filters: {
      toMoney (num) {
        if (!num) return '--'
        num = num.toFixed(2)
        num = parseFloat(num)
        num = num.toLocaleString()
        return num + ' 元' // 返回的是字符串23,245.12保留2位小数
      },
      toString (id) {
        return '' + id
      },
      formatYear: (val) => {
        var data = new Date(val)
        return data.getFullYear()
      }
    },
    mounted () {
      this.activeTab = '/report/form'
      this.$router.push({'path': '/report/form'})
      this.routeChange(this.$route)
      // this.fetchDepartment()
      setTimeout(() => {
        this.setTabs()
      }, 400)
    },
    methods: {
      fetchDepartment () {
        this.$store.dispatch('setDepartment', false)
      },
      setTabs () {
        this.tabs = [
          {'title': '应收款', 'key': '/report/form', 'visible': true},
          {'title': '部门', 'key': '/report/department', 'visible': this.$menu.isPower('report', 'project')},
          {'title': '项目', 'key': '/report/project', 'visible': this.$menu.isPower('report', 'project')},
          {'title': '汇总', 'key': '/report/count', 'visible': this.$menu.isPower('report', 'count')}
        ]
      },
      cascaderChange (value, selectedData) {
        this.formValidate.department = value[0]
        this.formValidate.project_id = value[1]
        if (this.formValidate.project === '') this.formValidate.project = selectedData[1].label
      },
      routeChange (route) {
        let action = route.params.action
        if (action === undefined || action === 'form') {
          this.activeTab = '/report/form'
          this.$router.push({'path': '/report/form'})
          // this.fetchData()
        } else if (action === 'count') {
          this.activeTab = '/report/count'
          this.$router.push({'path': '/report/count'})
          this.$store.dispatch('setDepartment')
          this.fetchCount()
          this.spinShow = false
        } else if (action === 'project') {
          this.activeTab = '/report/project'
          this.$router.push({'path': '/report/project'})
          this.fetchDepartmentGroup()
          this.fetchProject()
          this.spinShow = false
        } else if (action === 'department') {
          this.activeTab = '/report/department'
          this.$router.push({'path': '/report/department'})
          this.fetchDepartmentCount()
          this.spinShow = false
        }
      },
      exportTable () {
        var dom = document.getElementById('ifile')
        post('export/report/p').then(res => {
          if (res.status === 'success') {
            this.$Modal.success({
              title: '请求成功',
              content: '正在尝试生成excel数据, 请耐心等待...',
              okText: '关闭'
            })
            dom.src = this.apiPath + `export/report/p?cry=${res.cry}`
          }
        })
      },
      addProject () {
        post('console/reportProject', this.formValidate).then(res => {
          if (res.status === 'ok') {
            this.fetchProject()
          }
          this.$Message.info({content: res.msg})
        })
      },
      edit (row) {
        let dids = []
        this.dids = []
        this.formValidate = JSON.parse(JSON.stringify(row))
        dids[0] = this.formValidate.department
        dids[1] = this.formValidate.project_id ? this.formValidate.project_id : 0

        this.dids = dids
        this.addProjectForm = true
      },
      del (row) {
        this.$Modal.confirm({
          title: '删除确认',
          content: '确定要删除该内容吗？',
          onOk: () => {
            del(`console/reportProject/${row.id}`).then(res => {
              if (res.status === 'ok') this.fetchProject()
              this.$Message.info({content: res.msg})
            })
          }
        })
      },
      end (row) {
        this.$Modal.confirm({
          title: '项目完成',
          content: '确定项目已经全部到款吗？',
          onOk: () => {
            put(`console/reportProjectEnd/${row.id}`).then(res => {
              if (res.status === 'ok') this.fetchProject()
              this.$Message.info({content: res.msg})
            })
          }
        })
      },
      modalVisibleChange (visible) {
        if (!visible) {
          this.formValidate = {
            id: 0,
            project: '',
            department: '',
            year: '',
            company: '',
            expected: '',
            confirm: '',
            unconfirmed: ''
          }
        }
      },
      getChildren (month, data) {
        if (!data) return false
        for (let k in data) {
          // console.log(Number(data[k].month), Number(data))
          if (Number(data[k].month) === Number(month)) {
            return data[k]
          }
        }
        return false
      },
      reportsPageChange (page) {
        this.reports.current_page = page
        this.fetchCount()
      },
      fetchCount () {
        var params = JSON.parse(JSON.stringify(this.filter))
        // var date = new Date(this.filter.year)
        // var year = date.getFullYear()
        var col = {money: JSON.parse(JSON.stringify(moneyArr)), department: {name: ''}, company: '总计', confirm: '', name: '', project: '', expected: '', id: '', unconfirmed: '', year: '', total: '', children: [{month: 1, money: 0}, {month: 2, money: 0}, {month: 3, money: 0}, {month: 4, money: 0}, {month: 5, money: 0}, {month: 6, money: 0}, {month: 7, money: 0}, {month: 8, money: 0}, {month: 9, money: 0}, {month: 10, money: 0}, {month: 11, money: 0}, {month: 12, money: 0}]}
        params.page = this.reports.current_page
        fetch(`console/reportCount/all`, {params: params}).then(res => {
          var data = res
          data.data.push(col)
          if (data.data.length > 0) {
            this.formatDataToYear(data)
          }

          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      formatDataToYear (data) {
        var last = data.data[data.data.length - 1]
        for (let k in data.data) {
          var child = data.data[k].children
          var total = 0
          var money = JSON.parse(JSON.stringify(moneyArr))
          for (let i in money) {
            let c = this.getChildren(money[i].month, child)
            if (c && data.data[k].id !== '') {
              money[i].money = c.money
              let price = last.money[i].money === '--' ? c.money : (Number(last.money[i].money) + Number(c.money)).toFixed(2)
              last.money[i].money = price
              last.children[i].money = price
            }
          }
          for (let l in child) {
            let c = child[l]
            // if (child[l]) {
            //   col[l] = child[l] + Number(child.money)
            // } else {
            //   col.push(Number(child.money))
            // }
            total += Number(c.money)
          }
          if (data.data[k].id !== '') data.data[k].money = money
          data.data[k].total = total.toFixed(2)
        }
        this.reports = data
      },
      fetchDepartmentGroup () {
        fetch(`console/departmentGroup/all`).then(res => {
          this.departmentGroup = res
          this.currentDepartment = res[0].id
          this.fetchData()
          this.reportProjectYear()
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      reportProjectYear () {
        var data = new Date(this.year)
        var year = data.getFullYear()
        fetch(`console/reportProjectYear/all`, {params: {date: year}}).then(res => {
          this.projects = res
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      projectPageChange (page) {
        this.projectParams.page = page
        this.fetchProject()
      },
      departmentChange () {
        this.projectParams.page = 1
        this.fetchProject()
      },
      dateClick () {
        this.dateOpen = !this.dateOpen
      },
      dateChange (date) {
        this.projectParams.page = 1
        this.filterProject.year = date
      },
      fetchProject () {
        this.projectParams.department = this.filterProject.department
        this.projectParams.year = this.filterProject.year
        this.dateOpen = false
        fetch(`console/reportProject/all`, {params: this.projectParams}).then(res => {
          this.project = res
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      fetchDepartmentCount () {
        fetch(`console/reportProjectCount/all`).then(res => {
          this.projectCount = res
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      },
      rowClassName (row, index) {
        return index === this.reports.data.length - 1 ? 'table-last-row' : ''
      },
      exportData () {
        var type = 'year'
        var department = this.filter.department
        var date = new Date(this.filter.year)
        var year = date.getFullYear()

        var dom = document.getElementById('ifile')

        fetch(`console/initCountExport/all`).then(res => {
          if (res.status === 'ok') {
            this.$Message.info({content: '正在下载，请稍等...'})
            dom.src = this.apiPath + `report/export?cry=${res.cry}&type=${type}&department=${department}&year=${year}`
          }
          this.spinShow = false
        }).catch(() => {
          this.spinShow = false
        })
      }
    }
  }
</script>
